import type { CharacterActionKey } from "@/character/actions";
import type { CharacterGridSpec } from "@/character/grid";
import { createDefaultSkillBar, type SkillBarState } from "@/character/skills/types";
import type { StatAllocation } from "@/game/model/character-stats";
import { emptyAllocation } from "@/game/model/character-stats";

export type PetDefinition = {
  id: string;
  name: string;
  createdAt: number;
  spritesheetDataUrl: string;
  grid: CharacterGridSpec;
  actions: Record<CharacterActionKey, string>;
  apCardsApplied: number;
  sizeCardsApplied: number;
  statAllocation: StatAllocation;
  skillBar: SkillBarState;
};

export type PetPlayerState = {
  version: 1;
  equippedId: string | null;
  pets: PetDefinition[];
};

export function createEmptyPetState(): PetPlayerState {
  return { version: 1, equippedId: null, pets: [] };
}

export function emptyPetAllocation(): StatAllocation {
  return emptyAllocation();
}

export function defaultPetSkillBar(): SkillBarState {
  return createDefaultSkillBar();
}
